export default __webpack_public_path__ + "static/media/Hebbal.d38dbcfc.jpeg";